// Import Three.js Color class
import { Color } from 'three';
import { hasGlobalPropertyService, getGlobalPropertyService, PropertyType } from '@pointorama/potree-shared';

export const CameraMode = {
  ORTHOGRAPHIC: 0,
  PERSPECTIVE: 1,
  VR: 2,
};

export const ClipTask = {
  NONE: 0,
  HIGHLIGHT: 1,
  SHOW_INSIDE: 2,
  SHOW_OUTSIDE: 3,
  GRAYSCALE: 4,
  ACTIVE: 5,
  HEATMAP: 6,
};

export const ElevationGradientRepeat = {
  CLAMP: 0,
  REPEAT: 1,
  MIRRORED_REPEAT: 2,
};

export const MOUSE = {
  LEFT: 0b0001,
  RIGHT: 0b0010,
  MIDDLE: 0b0100,
};

export const PointSizeType = {
  FIXED: 0,
  ATTENUATED: 1,
  ADAPTIVE: 2,
};

export const PointShape = {
  SQUARE: 0,
  CIRCLE: 1,
  PARABOLOID: 2,
};

export const TreeType = {
  OCTREE: 0,
  KDTREE: 1,
};

export const LengthUnits = {
  METER: { code: 'm', unitspermeter: 1.0 },
  FEET: { code: 'ft', unitspermeter: 3.28084 },
  INCH: { code: '\u2033', unitspermeter: 39.3701 },
};

export const Colors = {
  EERIE_BLACK: 0x181818,
  PURPLE: 0x9600fa,
  NEON_GREEN: 0xb5ffa1,
  ASH_GREEN: 0x2f5954,
  ERROR_RED: 0xf24236, // 500,
};

/**
 * Read the user's default object color hex from the reactive property service.
 */
function getUserDefaultColorHex(): string | undefined {
  try {
    if (hasGlobalPropertyService()) {
      const value = getGlobalPropertyService().getProperty('user_default_object_color', '', PropertyType.USER_SETTINGS).value;
      if (typeof value === 'string' && value.startsWith('#')) return value;
    }
  } catch { /* service not ready */ }
  return undefined;
}

export const DefaultColors = {
  get OBJECTS() {
    const hex = getUserDefaultColorHex();
    return hex ? parseInt(hex.replace('#', ''), 16) : Colors.PURPLE;
  },
  get OBJECTS_THREE() {
    const hex = getUserDefaultColorHex();
    return hex ? new Color(hex) : new Color(Colors.PURPLE);
  },
  TEMPORARY_OBJECTS: new Color(Colors.NEON_GREEN),
  HIGHLIGHT: new Color(Colors.ASH_GREEN),
  HOVER: new Color(Colors.NEON_GREEN),
};
